<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Save as draft?
            </p>
            <button @click="closeModal" type="button" class="close-icon">
                <i class="mdi mdi-close"></i>
            </button>
        </header>
        <section class="modal-card-body padding-bottom82">

            <p :class="$style.modalContent">You are navigating away from project creation. 
                Do you want to save it as a draft? This project will be kept in Drafts under Projects page.</p>
            
        </section>
        <footer class="modal-card-foot">
            <button
                    class="button is-primary bg-white"
                    :class="[$style.btnExit, $style.exitColor]"
                    @click="exit"
            >
                Exit
            </button>

            <button
                    class="button is-primary is-rounded"
                    :class="$style.btnExit"
                    @click="save"
            >
                Save
            </button>
        </footer>
    </div>
</template>
<script lang="ts">
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Action} from 'vuex-class';

    @Component({ components: {}})

    export default class DeleteSiteModal extends Vue {
        public exit() {
            this.$emit('exit');
            this.$emit('close');
        }
        public closeModal() {
            this.$emit('close');
        }
        public save() {
            this.$emit('save');
            this.$emit('close');
        }
    }
</script>
<style module>
    .modalContent {
        color: #444f51;
    }
    .btnExit {
        width: 100px !important;
        height: 48px !important;
    }
    .exitColor {
        color: #00205B !important;
    }
</style>
